var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "569.000000pt",
    height: "438.000000pt",
    viewBox: "0 0 569.000000 438.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,438.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2670 4354 c-14 -2 -63 -9 -110 -15 -461 -59 -905 -283 -1250 -629 -382 -383 -593 -847 -640 -1405 -15 -171 2 -416 40 -597 122 -568 434 -1038 911 -1370 148 -104 277 -172 462 -244 119 -47 168 -48 211 -5 l31 31 0 205 c0 112 -3 206 -5 209 -3 3 -26 0 -50 -6 -74 -17 -266 -13 -339 6 -175 47 -289 149 -361 323 -49 119 -132 232 -205 280 -60 40 -115 95 -115 115 0 29 37 41 109 35 131 -9 239 -84 336 -232 66 -100 117 -148 204 -189 57 -27 79 -31 163 -34 81 -3 109 0 180 22 l85 26 12 53 c15 67 71 185 100 211 30 27 27 33 -26 40 -110 16 -284 60 -368 93 -129 51 -218 107 -305 193 -149 146 -226 319 -266 601 -42 299 21 548 196 769 19 25 19 25 -1 100 -27 101 -23 297 10 414 12 44 24 83 27 88 10 15 119 8 194 -13 87 -23 243 -96 348 -162 l73 -45 52 14 c277 74 715 74 994 0 l53 -14 92 56 c181 109 349 172 456 172 l60 0 16 -47 c40 -120 48 -170 48 -288 -1 -85 -6 -139 -19 -185 l-18 -65 53 -75 c101 -140 144 -250 163 -410 26 -229 -19 -509 -112 -694 -135 -267 -349 -407 -737 -483 l-142 -28 38 -51 c22 -29 51 -88 67 -135 l29 -84 5 -398 6 -399 28 -24 c44 -38 95 -32 242 27 501 200 903 565 1144 1037 165 324 241 644 241 1013 0 583 -226 1133 -635 1544 -335 338 -732 543 -1220 631 -85 15 -492 29 -555 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.b72ab60342b38b640979df62c444ab74.svg";
export { ForwardRef as ReactComponent };